<template>
	<div class="prepay">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.is_finish" placeholder="类型">
							<el-option label="全部" value=""></el-option>
							<el-option label="未结清" :value="0"></el-option>
							<el-option label="已结清" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="formfilter.month" type="month" placeholder="选择月份" format="yyyy-MM"
							value-format="yyyy-MM" :picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
						<i class="el-icon-question i" @click="onadd"></i>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="is_finish" label="状态" align="center" header-align="center" fixed="left" min-width="70px">
						<template slot-scope="scope">
							<div>{{scope.row.is_finish==0?'未结清':'已结清'}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="month_str" label="月份" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="total_money" label="下单金额" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.total_money== '0.00'">{{scope.row.total_money}}</div>
							<div class="a" v-else @click="onmlist(scope.row,1)">{{scope.row.total_money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="refund_money" label="退货金额" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.refund_money== '0.00'">{{scope.row.refund_money}}</div>
							<div class="a" v-else @click="onmlist(scope.row,2)">{{scope.row.refund_money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="loufa_money" label="漏发金额" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.loufa_money== '0.00'">{{scope.row.loufa_money}}</div>
							<div class="a" v-else @click="onmlist(scope.row,3)">{{scope.row.loufa_money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="stop_money" label="作废金额" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.stop_money== '0.00'">{{scope.row.stop_money}}</div>
							<div class="a" v-else @click="onmlist(scope.row,4)">{{scope.row.stop_money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="buchang" label="补偿给渠道" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.buchang== '0.00'">{{scope.row.buchang}}</div>
							<div class="a" v-else @click="onmlist(scope.row,5)">{{scope.row.buchang}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="work_buchang" label="工单补偿" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.work_buchang== '0.00'">{{scope.row.work_buchang}}</div>
							<div class="a" v-else @click="onmlist(scope.row,6)">{{scope.row.work_buchang}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="recharge_buyer" label="充值给买家" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.recharge_buyer== '0.00'">{{scope.row.recharge_buyer}}</div>
							<div class="a" v-else @click="onmlist(scope.row,7)">{{scope.row.recharge_buyer}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="pre_money" label="已预付金额" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.pre_money== '0.00'">{{scope.row.pre_money}}</div>
							<div class="a" v-else @click="onmlist(scope.row,8)">{{scope.row.pre_money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="pre_last_num" label="剩余预付次数" align="center" header-align="center" width="70px">
					</el-table-column>
					<el-table-column prop="pre_ratio" label="预付比例" align="center" header-align="center" width="60px">
					</el-table-column>
					<el-table-column prop="update_time_str" label="更新时间" align="center" header-align="center" width="100px">
					</el-table-column>
					<el-table-column prop="jiesuan_money" label="结算金额" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="confirm_jiesuan_money" label="确认结算金额" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="is_finish" label="状态" align="center" header-align="center" width="165px">
						<template slot="header" slot-scope="scope">
							<div>结算单</div>
							<div>未确认/已确认/已结算</div>
						</template>
						<template slot-scope="scope">
							<div>{{scope.row.is_admin_confirm}}/{{scope.row.is_user_confirm}}/{{scope.row.is_finish}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="90px">
						<template slot-scope="scope">
							<div class="operation_i">
								<div v-if="scope.row.is_admin_confirm == 1 && scope.row.is_user_confirm == 0">
									<span @click="onconfirm(scope.row,1)">去结算</span>
								</div>
								<div>
									<span @click="ondetailed(scope.row,1)">结算单</span>
								</div>
								<div v-if="scope.row.pre_last_num != 0">
									<span @click="onconfirm(scope.row,2)">预付申请</span>
								</div>
								<div>
									<span @click="ondetailed(scope.row,2)">预付列表</span>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		
		<el-dialog :title="type == 1? '结算':'预付申请'" :visible.sync="show" width="650px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
					<el-form-item :label="type == 1?'结算金额':'可预付金额'" class="item">
						<div v-if="type == 1">{{checkobj.confirm_jiesuan_money}}</div>
						<div v-if="type == 2">{{checkobj.can_pre_money}}</div>
					</el-form-item>
					<el-form-item label="充值金额" prop="money" class="item">
						<el-input-number v-model="ruleForm.money" :precision="2" :controls="false">
						</el-input-number>
					</el-form-item>
					<el-form-item :label="type == 1?'提现金额':'预付金额'" prop="money1" class="item">
						<el-input-number v-model="ruleForm.money1" :precision="2" :controls="false">
						</el-input-number>
					</el-form-item>
					<el-form-item label="收款账号" prop="bank_id" class="item myformitem">
						<el-select v-model="ruleForm.bank_id" placeholder="请选择收款账号">
							<el-option :label="v.ctype_str+'-'+v.account" :value="v.id" v-for="(v,k) in cwzh" :key="k">
								{{v.ctype_str}}-{{v.account}}
							</el-option>
						</el-select>
						<i class="i el-icon-circle-plus-outline" @click="onadd1()"></i>
						<p v-if="tshow" class="myjg">当选择了“对公银行账号”转账时，后续必须提供开票！</p>
					</el-form-item>
					<el-form-item label="备注" prop="remark" class="item">
						<el-input type="textarea" placeholder="" v-model="ruleForm.remark" :rows="3" maxlength="100"
							show-word-limit>
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :title="type == 1?'结算单':'预付列表'" :visible.sync="show1" width="90%" :before-close="onclose1">
			<div class="table_page">
				<div class="table">
					<el-table :data="list1" style="width: 100%" border>
						<el-table-column prop="state_str" label="状态" align="center" header-align="center" fixed="left">
						</el-table-column>
						<el-table-column prop="shop_name" label="渠道" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="money_month_str" label="月份" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="confirm_recharge_buyer" label="充值金额" align="center" header-align="center" v-if="type == 1">
						</el-table-column>
						<el-table-column prop="confirm_money" label="提现金额" align="center" header-align="center" v-if="type == 1">
						</el-table-column>
						<el-table-column prop="recharge_buyer" label="充值金额" align="center" header-align="center" v-if="type == 2">
						</el-table-column>
						<el-table-column prop="pre_money" label="预付金额" align="center" header-align="center" v-if="type == 2">
						</el-table-column>
						<el-table-column label="收款账号" align="center" header-align="center">
							<template slot-scope="scope">
								<div>{{scope.row.bank_arr.ctype_str}}-{{scope.row.bank_arr.account}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="create_time_str" label="申请时间" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="pay_time_str" label="付款时间" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center" header-align="center" fixed="right">
						</el-table-column>
						<el-table-column prop="audit_remark" label="审核备注" align="center" header-align="center">
						</el-table-column>
					</el-table>
				</div>
				<div class="page">
					<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
						:current-page.sync="page1" :page-size="pageSize1" :total="total1" v-if="total1 > 0"
						@current-change="handleCurrentChange1" @size-change="handleSizeChange1">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		
		<el-dialog title="财务明细" :visible.sync="show2" width="90%" :before-close="onclose2">
			<div class="table_page">
				<div class="table">
					<el-table :data="mlist" style="width: 100%" border>
						<el-table-column prop="trade_no" label="订单编号" align="center" header-align="center" fixed="left">
							<template slot-scope="scope">
								<div>{{scope.row.trade_no}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="shop_name" label="渠道" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="delivery_name" label="快递公司" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="money" label="变化金额" align="center" header-align="center">
							<template slot-scope="scope">
								<div>{{scope.row.ctype_tag}}{{scope.row.money}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="after_money" label="变化后余额" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="ctype_str" label="类型" align="center" header-align="center" fixed="right">
						</el-table-column>
					</el-table>
				</div>
				<div class="page">
					<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
						:current-page.sync="page1" :page-size="pageSize1" :total="total1" v-if="total1 > 0"
						@current-change="handleCurrentChange2" @size-change="handleSizeChange2">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		
		<add ref="add" :type="1" @upadd="oncwzh()"></add>
		<el-dialog title="" :visible.sync="show3" width="650px" :before-close="onclose3">
			<mtext v-if="show3" :type="1"></mtext>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Prepay',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				
				formfilter: {
					is_finish: 0,
					shop_id: "",
					month: ""
				},
				
				qudao: [],
				filtershow: true,
				
				type: 0,
				ruleForm: {
					money: "",
					money1: "",
					bank_id: "",
					remark: ""
				},
				
				rules: {
					money: [{
						required: true,
						message: '请输入充值给买家金额',
						trigger: 'blur'
					}],
					money1: [{
						required: true,
						message: this.type == 1?'请输入结算提现的金额':'预付金额',
						trigger: 'blur'
					}],
					bank_id: [{
						required: true,
						message: '请选择收款账号',
						trigger: 'change'
					}],
				},
				
				show: false,
				checkobj: {},
				cwzh: [],
				
				show1: false,
				show2: false,
				list1: [],
				ctype_num: 0,
				mlist: [],
				page1: 1,
				pageSize1: 20,
				total1: 0,
				tshow: false,
				show3: false,
				
				pickerOptions: {
					disabledDate: (time) => {
						return Date.now() - 3600 * 1000 * 24 < time.getTime();
					}
				}
				
			}
		},
		
		mounted() {
			this.onlist();
			this.onqudao();
			this.oncwzh();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		watch: {
			'ruleForm.bank_id': {
				handler(newQuery, oldQuery) {
					this.tshow = false;
					if(newQuery && this.cwzh.length > 0) {
						this.cwzh.forEach((v,k)=>{
							if(v.id == newQuery) {
								if(v.ctype == 1) {
									this.tshow = true;
								}
							}
						})
					}
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true ,// 组件创建时立即执行一次handler
			}
		},
		
		methods: {
			handleCurrentChange() {
				this.onlist();
			},
		
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
		
			onfilter() {
				this.page = 1;
				this.onlist();
			},
		
			onreset() {
				this.formfilter = {
					is_finish: 0,
					month: "",
					shop_id: ""
				};
				this.page = 1;
				this.onlist();
			},
		
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
		
				this.$axios.post('api/user/user_shop_money_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};
			
				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			oncwzh(val,t) {
				var obj = {};
				obj.page = 1;
				obj.limit = 10000;
			
				this.$axios.post('api/user/user_bank_list', obj).then(res => {
					if (res.data.code == 0) {
						this.cwzh = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onconfirm(obj,t) {
				this.checkobj = obj;
				this.type = t;
				this.show = true;
			},
			
			onclose() {
				this.checkobj = {};
				this.show = false;
				this.type = 0;
				this.ruleForm = {
					money: "",
					money1: "",
					bank_id: "",
					remark: ""
				};
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
						var obj = {};
						obj.remark = ruleForm.remark;
						obj.bank_id = ruleForm.bank_id;
						if(this.type == 1) {
							obj.id = this.checkobj.id;
							obj.confirm_recharge_buyer = ruleForm.money;
							obj.confirm_money = ruleForm.money1;
							this.$axios.post('api/user/user_confirm_shop_money', obj).then(res => {
								if (res.data.code == 0) {
									this.$message.success('操作成功');
									this.onclose();
									this.onlist();
								} else {
									this.$message.error(res.data.message);
								}
							}).catch(err => {
								console.log(err)
							})
						}
						
						if(this.type == 2) {
							obj.money_id = this.checkobj.id;
							obj.recharge_buyer = ruleForm.money;
							obj.pre_money = ruleForm.money1;
							this.$axios.post('api/user/user_prepay', obj).then(res => {
								if (res.data.code == 0) {
									this.$message.success('操作成功');
									this.onclose();
									this.onlist();
								} else {
									this.$message.error(res.data.message);
								}
							}).catch(err => {
								console.log(err)
							})
						}
					}
				})
			},
			
			ondetailed(obj,t) {
				this.checkobj = obj;
				this.show1 = true;
				this.type = t;
				this.ondetail();
			},
			
			onclose1() {
				this.checkobj = {};
				this.show1 = false;
				this.list1 = [];
				this.type = 0;
				this.page1 = 1;
				this.pageSize1 = 20;
				this.total1 = 0;
			},
			
			handleCurrentChange1() {
				this.ondetail();
			},
			
			handleSizeChange1(val) {
				this.page1 = 1;
				this.pageSize1 = val;
				this.ondetail();
			},
			
			ondetail() {
				var obj = {
					money_id: this.checkobj.id,
					state: ""
				};
				obj.page = this.page1;
				obj.limit = this.pageSize1;
				
				if(this.type == 1) {
					obj.shop_id = "";
					this.$axios.post('api/user/user_confirm_shop_money_list', obj).then(res => {
						if (res.data.code == 0) {
							this.total1 = res.data.data.count;
							this.list1 = res.data.data.list;
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}
				
				if(this.type == 2) {
					this.$axios.post('api/user/user_prepay_list', obj).then(res => {
						if (res.data.code == 0) {
							this.total1 = res.data.data.count;
							this.list1 = res.data.data.list;
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			
			onmlist(obj,n) {
				this.checkobj = obj;
				this.show2 = true;
				this.ctype_num = n;
				this.onlog();
			},
			
			onclose2() {
				this.checkobj = {};
				this.show2 = false;
				this.mlist = [];
				this.page1 = 1;
				this.pageSize1 = 20;
				this.total1 = 0;
				this.ctype_num = 0;
			},
			
			handleCurrentChange2() {
				this.onlog();
			},
			
			handleSizeChange2(val) {
				this.page1 = 1;
				this.pageSize1 = val;
				this.onlog();
			},
			
			onlog() {
				var obj = {
					money_id: this.checkobj.id,
					shop_id: "",
					trade_no: "",
					delivery_name: "",
					ctype: this.ctype_num,
					btime: "",
					etime: ""
				};
				obj.page = this.page1;
				obj.limit = this.pageSize1;
						
				this.$axios.post('api/user/user_shop_money_log_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total1 = res.data.data.count;
						this.mlist = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onadd1() {
				this.$refs.add.show2 = true;
			},
			
			onadd() {
				this.show3 = true;
			},
			
			onclose3() {
				this.show3 = false;
			}
		}
	}
</script>

<style scoped lang="less">
	.prepay {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 72px);
	}
	
	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
	
	/deep/ .item .el-select {
		width: 400px;
	}
	
	/deep/ .item .el-input-number {
		width: 400px;
	}
	
	/deep/ .item .el-textarea {
		width: 400px;
	}
	
	.page {
		width: 100%;
		margin-top: 20px;
	}
	
	.a {
		cursor: pointer;
	}
	
	.myformitem {
		.i {
			right: 60px;
		}
	}
	
	.filterty .i {
		font-size: 18px;
		margin-left: 14px;
		cursor: pointer;
		color: #D8DBDD;
	}
</style>


// WEBPACK FOOTER //
// src/components/seller/prepay.vue